<script>
import store from '@state/store'
import { debounce } from 'debounce'

export default {
  data() {
    return {
      causeTag: '',
      causeDisplayTags: [],
      causeTags: [],

      orgTag: '',
      orgDisplayTags: [],
      orgTags: [],
    }
  },
  watch: {
    causeTag: 'getCauses',
    orgTag: 'searchOrganization',
  },
  methods: {
    changeDataToTags(data) {
      if (!data || !data.length) return data
      const newData = data.map((item) => {
        const { id, name } = item
        return { id, text: name }
      })
      return newData
    },
    updateCauseTags(newTags) {
      this.causeTags = newTags
    },
    getCauses() {
      if (this.causeDisplayTags.length) {
        return
      }
      store.dispatch('adminGroups/getCauses').then((data) => {
        if (data instanceof Array && data.length) {
          this.causeDisplayTags = this.changeDataToTags(data)
        }
      })
    },
    updateOrgTags(newTags) {
      this.orgDisplayTags = []
      this.orgTags = newTags
    },
    searchOrganization: debounce(async function searchUsers() {
      if (!this.orgTag || this.orgTags.length) {
        return
      }
      store
        .dispatch('adminGroups/searchOrganization', {
          orgTag: this.orgTag,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            data.slice(0, 15)
            this.orgDisplayTags = this.changeDataToTags(data)
          }
        })
    }, 500),
  },
}
</script>
